export default __webpack_public_path__ + "static/O0153-d4732d0206196d25d6286687b5a04106.png";